import { render, staticRenderFns } from "./landStatictics.vue?vue&type=template&id=d7fe0854&scoped=true"
import script from "./landStatictics.vue?vue&type=script&lang=js"
export * from "./landStatictics.vue?vue&type=script&lang=js"
import style0 from "./landStatictics.vue?vue&type=style&index=0&id=d7fe0854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fe0854",
  null
  
)

export default component.exports